import { apiClient } from './ApiClient';
import type { UserApiKeyStatus, ApiKeyProvider } from '@photomaton/shared';

export interface SaveApiKeyResponse {
  success: boolean;
  message: string;
  data: UserApiKeyStatus;
}

export interface DeleteApiKeyResponse {
  success: boolean;
  message: string;
}

export interface ApiKeyStatusesResponse {
  success: boolean;
  data: UserApiKeyStatus[];
}

export class ApiKeyService {
  /**
   * Get all API key statuses for the current user
   */
  async getStatuses(): Promise<UserApiKeyStatus[]> {
    const response = await apiClient.get<ApiKeyStatusesResponse>('/apikeys');
    return response.data;
  }

  /**
   * Get API key status for a specific provider
   */
  async getStatus(provider: ApiKeyProvider): Promise<UserApiKeyStatus> {
    const response = await apiClient.get<{ success: boolean; data: UserApiKeyStatus }>(
      `/apikeys/${provider}`
    );
    return response.data;
  }

  /**
   * Save or update an API key
   */
  async saveApiKey(provider: ApiKeyProvider, apiKey: string): Promise<SaveApiKeyResponse> {
    return apiClient.post<SaveApiKeyResponse>('/apikeys', {
      provider,
      apiKey,
    });
  }

  /**
   * Re-validate an existing API key
   */
  async validateApiKey(provider: ApiKeyProvider): Promise<{ success: boolean; message: string; data: UserApiKeyStatus }> {
    return apiClient.post<{ success: boolean; message: string; data: UserApiKeyStatus }>(
      `/apikeys/${provider}/validate`
    );
  }

  /**
   * Delete an API key
   */
  async deleteApiKey(provider: ApiKeyProvider): Promise<DeleteApiKeyResponse> {
    return apiClient.delete<DeleteApiKeyResponse>(`/apikeys/${provider}`);
  }
}

export const apiKeyService = new ApiKeyService();
